export default __webpack_public_path__ + "assets/mobilepay_grey-c22a215dc486710aa5d8d957d1e3db32.png";